import { Container, IInit } from '../../../common/container/Container'
import { Observable } from 'rxjs'
import { FavProduct, FavProductQuery, Product, ProductQuery } from '../models/Product'
import { ItemList } from '../../../common/models/ItemList'
import { Query } from '../../../common/api/Query'
import { FavProductDTO, ProductDTO } from '../models/ProductDTO'
import { IProductApi } from '../api/ProductApi'
import { IStatusService } from '../../../common/status/StatusService'
import { STATUS_SERVICE_KEY } from '../../../container/app'

type Props = {
  apiKey: symbol
}

export interface IProductService extends IInit {
  getByID(id: string): Observable<Product | undefined>

  getFilteredList(q: Query<ProductQuery>): Observable<ItemList<Product>>

  add(e: Product): Observable<Product | undefined>

  update(e: ProductDTO): Observable<Product | undefined>

  delete(id: string): Observable<boolean>

  getFilteredListFromDatabase(q: Query<ProductQuery>): Observable<ItemList<Product>>

  getFilteredListUpdated(q: Query<ProductQuery>): Observable<ItemList<Product>>

  updateFromOdoo(e: ProductDTO): Observable<Product | undefined>

  addFav(e: FavProductDTO): Observable<FavProduct | undefined>

  getFavList(q: Query<FavProductQuery>): Observable<string[]>
   
  deleteFav(q: Query<FavProductQuery>): Observable<boolean>


}

export class ProductService implements IProductService {
  private readonly _apiKey: symbol
  private _container!: Container
  private _api!: IProductApi
  private _statusService!: IStatusService

  constructor(p: Props) {
    this._apiKey = p.apiKey
  }

  init(c: Container) {
    this._container = c
    this._api = this._container.get<IProductApi>(this._apiKey)
    this._statusService = this._container.get<IStatusService>(STATUS_SERVICE_KEY)
  }

  add(e: ProductDTO): Observable<Product | undefined> {
    return this._api.add(e)
  }

  delete(id: string): Observable<boolean> {
    return this._api.delete(id)
  }

  getByID(id: string): Observable<Product | undefined> {
    return this._api.getByID(id)
  }

  getFilteredList(q: Query<ProductQuery>): Observable<ItemList<Product>> {
    return this._api.getFilteredList(q)
  }

  getFilteredListFromDatabase(q: Query<ProductQuery>): Observable<ItemList<Product>> {
    return this._api.getFilteredListFromDatabase(q)
  }

  getFilteredListUpdated(q: Query<ProductQuery>): Observable<ItemList<Product>> {
    return this._api.getFilteredListUpdated(q)
  }

  update(e: ProductDTO): Observable<Product | undefined> {
    return this._api.update(e)
  }

  updateFromOdoo(e: ProductDTO): Observable<Product | undefined> {
    return this._api.updateFromOdoo(e)
  }

  addFav(e: FavProductDTO): Observable<FavProduct | undefined> {
    return this._api.addFav(e)
  }

  getFavList(q: Query<FavProductQuery>): Observable<string[]> {
    return this._api.getFavList(q)
  }

  deleteFav(q: Query<FavProductQuery>): Observable<boolean> {
    return this._api.deleteFav(q)
  }
}
